export type DailyAvailability = {
  [key: string]: boolean;
};

export type DaySelectionPanelProps = {
  selectedDays: DailyAvailability;
  onToggleDay: (day: string) => void;
};

export const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
